import { ReferenceData } from './reference-data.model';

export class SalaryPlan extends ReferenceData {

  standardHours: string;
  frequencyId: { correlation: string };

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.frequencyId = data.frequencyId;
    this.standardHours = data.standardHours;
  }
}
